import React, { useState } from "react";

import "./style.scss";

interface RejectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  uploadName: string;
  title?: string;
  description?: string;
}

const RejectionModal: React.FC<RejectionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  uploadName,
  title = "Reject Upload",
  description,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleReject = async () => {
    if (!reason.trim()) {
      setError("This field is required");
      return;
    }

    setIsLoading(true);
    await onConfirm(reason);
    setIsLoading(false);
    setReason("");
    setError("");
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <div className="rejection-modal-backdrop">
      <div className="rejection-modal-content">
        <div className="rejection-modal-header">
          <div className="rejection-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
          <h2 className="rejection-title">{title}</h2>
        </div>

        <div className="rejection-message">
          <p>
            {description ||
              `Please provide a reason for rejecting "${uploadName}". The uploader will be notified of the rejection.`}
          </p>
        </div>

        <div className="rejection-form">
          <label className="rejection-label">
            Reason <span className="required-asterisk">*</span>
          </label>
          <textarea
            className={`rejection-textarea ${error ? "error" : ""}`}
            placeholder="Enter rejection reason..."
            value={reason}
            onChange={e => {
              setReason(e.target.value);
              if (error) setError("");
            }}
            rows={5}
            disabled={isLoading}
          />
          {error && <span className="error-text">{error}</span>}
        </div>

        <div className="rejection-actions">
          <button
            className="cancel-btn"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="reject-btn"
            onClick={handleReject}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Rejecting...
              </>
            ) : (
              "Reject Upload"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
